import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IReceptionNotification } from "@/models";

@Component({
    name: "notificationAskReception",
})

export default class NotificationAskReception extends Vue {

    @Prop({ required: true })
    public notification: IReceptionNotification;

    public constructor() {
        super();
    }

    public goNewReception(): void {
        this.$store.commit("receptions/SET_SELECTED_NOTIFICATION", this.notification);

        this.$router.push({ name: "receptionCreate" });
    }

    public get waitingFor(): string {
        const waiting = this.$store.state.app.now.getTime() - new Date(this.notification.startTime).getTime();
        return `${waiting > 0 ? Math.round(waiting / 1000 / 60) : 0} min`;
    }
}
